// extracted by mini-css-extract-plugin
module.exports = {"date":"date_date__rfgM8","onDark":"date_onDark__O9hm2"};